import MobileDetect from 'mobile-detect';

import {} from 'history';

export type {};

declare global {
  let CKEDITOR: any;

  interface Window {
    debugger?: boolean;
    mobileDetection: MobileDetect;
    browserHistory: any;
    CKEDITOR?: any;
    CKEDITOR_BASEPATH: string;
  }

  function BzNotFalsy<T>(arg: T | undefined | null): arg is T;
  function BzNotNull<T>(arg: T | undefined | null): arg is T;
}

Object.defineProperty(window, 'BzNotFalsy', {
  writable: false,
  enumerable: false,
  value: function <T>(arg: T | undefined | null): arg is T {
    return !!arg;
  }
});

Object.defineProperty(window, 'BzNotNull', {
  writable: false,
  enumerable: false,
  value: function <T>(arg: T | undefined | null): arg is T {
    return arg != null;
  }
});

window.mobileDetection = new MobileDetect(window.navigator.userAgent);
